import React, { useEffect, useState, Fragment, useRef } from "react";
import { ReportTableContent } from '../../../Common/Table/tableContent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const data = this.props.data;
        const searchData = this.props.searchData;
        const totalCount = this.props.totalAmount;

        return (
            <div className="p-2">
                <h3><center><u>Cash And Block Summary Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.collectionPoint}</div>
                    <div className="col"><b>Date: </b> {searchData.month}</div>
                </div>
                <TableContainer component={Paper}>
                    <div className="row alternative_cls bg-light  ">
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Reg No
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Employee Name
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Total
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row) => (
                                    <TableRow key={row.registrationNumber}>
                                        <TableCell component="th" align="left" >
                                            {row.registrationNumber}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.firstName}
                                        </TableCell>
                                        <TableCell align="center">{row.total}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={2} style={{ fontWeight: "bold" }} align="left">
                                        Total
                                    </TableCell>
                                    <TableCell style={{ fontWeight: "bold" }} align="center">
                                        {totalCount}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </div>
                </TableContainer>
            </div>
        );
    }
}